import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { normalizeApiUrl, tenantHostApiMap } from './environments/tenant-hosts';

const hostname = window.location.hostname.toLowerCase();
const mappedApiUrl = tenantHostApiMap[hostname];
if (mappedApiUrl) {
  environment.apiUrl = normalizeApiUrl(mappedApiUrl);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
